import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => {
  const commonCalendarEventStyles = {
    background: "darkgreen",
    borderRadius: theme.shape.borderRadius,
  };

  return {
    container: {
      height: "90%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    reservationsCalendar: {
      width: "100%",
    },
    filtersPicker: {
      width: "100%",
    },
    filtersPickerContainer: {
      width: "100%",
      minWidth: "100px",
    },
    defaultCalendarEvent: {
      ...commonCalendarEventStyles,
    },
    deletedCalendarEvent: {
      ...commonCalendarEventStyles,
      background: "darkred",
      textDecoration: "line-through !important",
    },
    pendingProviderEvent: {
      ...commonCalendarEventStyles,
      backgroundColor: "gold",
    },
    pendingPaymentEvent: {
      ...commonCalendarEventStyles,
      backgroundColor: "darkorange",
    },
  };
});
